<div class="link-patient-warning {{styleClass}}" *ngIf="showWarning">
  <ng-container *ngIf="hasSmsVerification || hasEmailVerification; else completeData">
    <si-generic-alert [(showAlert)]="showWarning"
                      text="SI_IDENTITY_VERIFICATION_TEXT"
                      [clickable]="true"
                      [closable]="true"
                      (clickAlert)="onClickVerifyIdentity()"
                      (closeAlert)="onClickCloseIcon()"
    ></si-generic-alert>
  </ng-container>
  <ng-template #completeData>
    <si-generic-alert [(showAlert)]="showWarning"
                      text="SI_COMPLETE_PATIENT_DATA_TEXT"
                      [href]="['/profile/link-patient']"
                      [closable]="true"
                      (closeAlert)="onClickCloseIcon()"
    ></si-generic-alert>
  </ng-template>
</div>
<si-verification-parent [reloadImmediately]="true"
                        [linkPatientVerification]="linkPatientVerification"
                        (linkPatientSuccessChange)="onFinishVerification()"
></si-verification-parent>
